<script lang="ts">
	interface Props {
		firstWidth?: string;
		chevronLeft?: string;
		chevronTop?: string;
		dividerOffset?: string;
	}

	let {
		firstWidth = '21px',
		chevronLeft = '18px',
		chevronTop = '-5px',
		dividerOffset = '35px',
	}: Props = $props();
</script>

<div class="crazy-divider-container d-flex justify-content-between">
	<div class="crazy-divider-first" style="width: {firstWidth};"></div>
	<i class="fa-light fa-chevron-down" style="left: {chevronLeft}; top: {chevronTop};"></i>
	<div class="crazy-divider-divider" style="width: calc(100% - {dividerOffset});"></div>
</div>

<style>
	.crazy-divider-container {
		position: relative;
		width: 100%;
	}

	.crazy-divider-first {
		border-bottom: 1px solid #303235;
	}

	.crazy-divider-container > i {
		position: absolute;
		color: #303235;
	}

	.crazy-divider-divider {
		border-bottom: 1px solid #303235;
	}
</style>
